import React, { useMemo } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import ModaArticoliQuickSearches from "./ModaArticoliQuickSearches";
import "./modaArticoliToolbar.css";

function ModaArticoliFilters({
  quickSearch,
  onQuickSearchChange,
  onQuickSearchSubmit,
  onResetFilters,
  onOpenAdvancedFilters,
  onOpenBulkAssign,
  onRefresh,
  onOpenFunctions,
  appliedFilters,
  mobile = false,
  onShowAssigned,
  onShowNeedTexts,
  onShowNeedImages,
  loading = false,
  canBulkAssign = false,
  columnsControl,
  viewMode,
  quickSearchChoiceGroups,
  appliedFilterRemovalActions,
}) {
  const { tastoCercaAspetto, tastoRefreshAspetto, tastoCercaAvanzataAspetto,
    tastoToolsAspetto, tastoResetAspetto } = stilePulsanti;
  const buttonClass = "dim tastoInputOrizzontale br3 moda-articoli-toolbar-button";

  const activeFiltersCount = useMemo(() => {
    if (!appliedFilters) {
      return 0;
    }
    return Object.values(appliedFilters).filter(
      (value) => value !== undefined && value !== null && String(value).trim()
    ).length;
  }, [appliedFilters]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onQuickSearchSubmit();
  };

  const renderAppliedFilters = () => {
    if (!appliedFilters || activeFiltersCount === 0) {
      return null;
    }
    return (
      <div className="mt2 flex flex-wrap items-center f7">
        {Object.entries(appliedFilters)
          .filter(
            ([, value]) =>
              value !== undefined &&
              value !== null &&
              String(value).trim().length > 0
          )
          .map(([key, value]) => (
            <span
              key={key}
              className="mr2 mb2 ph2 pv1 br-pill bg-washed-blue dark-blue"
            >
              {key}: <strong>{value}</strong>
              {appliedFilterRemovalActions?.[key] && <button type="button"
                className="ml1 bn bg-transparent pointer color-inherit" aria-label={`Rimuovi filtro ${key}`}
                title={`Rimuovi filtro ${key}`} disabled={loading}
                onClick={appliedFilterRemovalActions[key]}>×</button>}
            </span>
          ))}
      </div>
    );
  };

  return (
    <div className="moda-articoli-filters">
      <div className={`moda-articoli-toolbar${mobile ? " moda-articoli-toolbar-mobile" : ""}`}>
        <form onSubmit={handleSubmit} className="moda-articoli-search">
          <input type="text" value={quickSearch}
            aria-label="Ricerca tra i risultati (codice, descrizioni, brand...)"
            placeholder="Ricerca tra i risultati (codice, descrizioni, brand...)"
            onChange={(event) => onQuickSearchChange(event.target.value)}
            className="inputOrizzontale br3 moda-articoli-quick-input measure" />
          <button type="submit" className={buttonClass} title="Cerca" aria-label="Cerca" disabled={loading}>
            <div aria-hidden="true">{tastoCercaAspetto}</div>
          </button>
          <button type="button" className={buttonClass} title="Filtri avanzati" data-active={activeFiltersCount > 0}
            aria-label={`Filtri avanzati${activeFiltersCount ? ` (${activeFiltersCount})` : ""}`}
            onClick={onOpenAdvancedFilters} disabled={loading}>
            <div aria-hidden="true">{tastoCercaAvanzataAspetto}</div>
            {activeFiltersCount > 0 && <span className="moda-articoli-filter-count" aria-hidden="true">{activeFiltersCount}</span>}
          </button>
          {activeFiltersCount > 0 && <button type="button" className={buttonClass}
            title="Pulisci filtri" aria-label="Pulisci filtri" onClick={onResetFilters} disabled={loading}>
            <div aria-hidden="true">{tastoResetAspetto}</div>
          </button>}
          <button type="button" className={buttonClass} title="Aggiorna" aria-label="Aggiorna"
            onClick={onRefresh} disabled={loading}>
            <div aria-hidden="true">{tastoRefreshAspetto}</div>
          </button>
          <ModaArticoliQuickSearches loading={loading} viewMode={viewMode} choiceGroups={quickSearchChoiceGroups}
            onShowAll={onResetFilters} onShowAssigned={onShowAssigned}
            onShowNeedTexts={onShowNeedTexts} onShowNeedImages={onShowNeedImages} />
        </form>
        <div className="moda-articoli-actions">
          {canBulkAssign && <button type="button" className={buttonClass}
            title="Assegna lavorazioni" aria-label="Assegna lavorazioni" onClick={onOpenBulkAssign} disabled={loading}>
            <span className="material-icons colScrittaDef-20" aria-hidden="true">assignment</span>
          </button>}
          {onOpenFunctions && <button type="button" className={buttonClass}
            title="Funzioni" aria-label="Funzioni" onClick={onOpenFunctions} disabled={loading}>
            <div aria-hidden="true">{tastoToolsAspetto}</div>
          </button>}
          {columnsControl}
        </div>
      </div>
      {renderAppliedFilters()}
    </div>
  );
}

export default ModaArticoliFilters;
